module.exports = __webpack_public_path__ + "img/api3.c34a1c6a.svg";